import { useContext, useEffect, useState } from "react";
import {
  getCampaigns,
  createCampaign,
  updateCampaign,
  deleteCampaign,
} from "../services/configurations/campaigns";
import { MarketingCampaign } from "../interfaces/BDModels";
import { AppContext } from "../context";

type DataResponseType = "DATA" | "ACTIONS";
export type ActionType = "CREATE" | "UPDATE" | "DELETE";

const handleActionFunction = (action: ActionType, t: Function) => {
  switch (action) {
    case "CREATE":
      return {
        actionFn: createCampaign,
        fnMsg: t("IuviMarketing.apiCreateLabel"),
      };
    case "UPDATE":
      return {
        actionFn: updateCampaign,
        fnMsg: t("IuviMarketing.apiUpdateLabel"),
      };
    case "DELETE":
      return {
        actionFn: deleteCampaign,
        fnMsg: t("IuviMarketing.apiDeleteLabel"),
      };
    default:
      return {
        actionFn: () => {},
        fnMsg: "",
      };
  }
};

export const useCampaigns = (type?: DataResponseType) => {
  const {
    t,
    toast,
    appState: { selectedApp },
    setAppState,
  } = useContext(AppContext);
  const [data, setData] = useState<MarketingCampaign[] | null>(null);
  const [reload, setReload] = useState<number>(0);
  const appid = selectedApp?.appid || '0';

  const reloadFn = () => {
    setData(null);
    setReload((prev) => prev + 1);
  };

  const campaignAction = async (action: ActionType, data: any) => {
    const { actionFn, fnMsg } = handleActionFunction(action, t);
    setAppState((prev) => ({
      ...prev,
      isLoading: true,
    }));
    const actionStatus = await Promise.resolve(actionFn(data, appid))
      .then((response) => {
        toast.current.replace({
          severity: "success",
          summary: "",
          detail: `${fnMsg}`,
          life: 3000,
        });
        return 'SUCCESS'
      })
      .catch((error) => {
        toast.current.replace({
          severity: "error",
          summary: "",
          detail: error?.response?.data?.header?.errorMsg ?? t('ConsoleTranslations.generalErrorApiMessage'),
          life: 3000,
        });
        return 'ERROR'
      });
    setAppState((prev) => ({
      ...prev,
      isLoading: false,
    }));
    return actionStatus
  };

  useEffect(() => {
    if (type === "DATA" && appid) {
      (async function () {
        await Promise.resolve(getCampaigns(appid))
          .then((response) => {
            setData(response?.data);
          })
          .catch((error) => {
            toast.current.replace({
              severity: "error",
              summary: "",
              detail: error?.response?.data?.header?.errorMsg ?? t('ConsoleTranslations.generalErrorApiMessage'),
              life: 3000,
            });
          });
      })();
    }
  }, [appid, toast, type, reload]);

  return {
    data,
    campaignAction,
    reloadFn,
  };
};
